import { z } from 'zod';
import { createRepo } from './_base.js';

/**
 * Sprint 88 — hostname → brand index, mirroring marketing/dashboard.
 * O(1) brand resolution for the agent-pwa shell. Public-read by rule.
 */
const HostnameToBrandSchema = z.object({ platformBrandId: z.string() });
export const hostnameToBrandRepo = createRepo({
  path: 'hostnameToBrand',
  schema: HostnameToBrandSchema,
  name: 'hostnameToBrand',
});
